module.exports = __webpack_public_path__ + "static/media/Spanish_US_Rosa BG-47.c7eea586.png";